export const blogCategoryFilter = () => {
	const root = document.querySelector('.blog');

	if (!root) {
		return;
	}

	const buttons = Array.from(root.querySelectorAll('.hero__category'));

	if (!buttons.length) {
		return;
	}

	const setActiveButton = (category) => {
		buttons.forEach((button) => {
			const isActive = (button.dataset.category || 'all') === category;
			button.classList.toggle('hero__category--active', isActive);
		});
	};

	const goToCategory = (category) => {
		const url = new URL(window.location.href);
		url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');

		if (!category || category === 'all') {
			url.searchParams.delete('blog_category');
		} else {
			url.searchParams.set('blog_category', category);
		}

		url.searchParams.delete('paged');
		window.location.href = url.toString();
	};

	buttons.forEach((button) => {
		button.addEventListener('click', () => {
			const category = button.dataset.category || 'all';
			setActiveButton(category);
			goToCategory(category);
		});
	});

	const initialActiveButton = buttons.find((button) => button.classList.contains('hero__category--active')) || buttons[0];
	const initialCategory = initialActiveButton?.dataset.category || 'all';

	setActiveButton(initialCategory);
};
